// extracted by mini-css-extract-plugin
module.exports = {"BackdropPopupContainer":"BackdropPopup_BackdropPopupContainer__2lnDO","BackdropPopup":"BackdropPopup_BackdropPopup__1_wxy"};